(function() {
  'use strict';
  angular.module('userProfile', ['dnSecurity','dnErrorDisplay', 'common']);
})();
